import { render } from "./spass.vue?vue&type=template&id=380ebbfc&scoped=true"
const script = {}

import "./spass.vue?vue&type=style&index=0&id=380ebbfc&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380ebbfc"]])

export default __exports__